<template>
  <el-form-item>
    <el-checkbox :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
      <span>我已阅读并同意</span>
      <button type="button" class="link-btn" @click="openUserAgreement">《用户协议》</button>
      <span>和</span>
      <button type="button" class="link-btn" @click="openPrivacyPolicy">《隐私协议》</button>
    </el-checkbox>
  </el-form-item>
</template>

<script setup>
import {defineProps, defineEmits} from 'vue';
defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

defineEmits(['update:modelValue'])

// 打开隐私协议页面
const openPrivacyPolicy = () => {
  const privacyPolicyUrl = 'https://www.wiseagent.com.cn:10443/preview/privacy'
  if (privacyPolicyUrl) {
    window.open(privacyPolicyUrl, '_blank')
  }
}

// 打开用户协议页面
const openUserAgreement = () => {
  const userAgreementUrl = 'https://www.wiseagent.com.cn:10443/preview/agreement/client'
  if (userAgreementUrl) {
    window.open(userAgreementUrl, '_blank')
  }
}
</script>

<style scoped>
.link-btn {
  color: #1890ff;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0.25rem;
  font: inherit;
  text-decoration: none;
  transition: color 0.3s;
}

.link-btn:hover {
  color: #40a9ff;
  text-decoration: underline;
}

:deep(.el-checkbox__label) {
  font-size: 0.9375rem;
  color: #333;
}
</style>

